import React from "react";

const Pagination = ({
  totalCount,
  pageSize,
  currentPage,
  onPageChange,
  onItemsPerPageChange,
}) => {
 console.log("totalCount:", totalCount, "pageSize:", pageSize, "currentPage:", currentPage);
const totalPages = Math.ceil(totalCount / pageSize);

  const getPages = () => {
    const pages = [];

    if (totalPages <= 4) {
      // Show all pages if total is 4 or less
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);

      if (currentPage <= 3) {
        // Show pages 2, 3, 4
        for (let i = 2; i <= Math.min(4, totalPages); i++) {
          pages.push(i);
        }
        if (totalPages > 4) {
          pages.push("...");
        }
      } else if (currentPage >= totalPages - 2) {
        // Show ellipsis and last 4 pages
        pages.push("...");
        for (let i = Math.max(2, totalPages - 3); i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Show ellipsis, current page with neighbors, and ellipsis
        pages.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push("...");
      }

      // Always show last page if not already included
      if (totalPages > 1 && !pages.includes(totalPages)) {
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const pagesToShow = getPages();

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-3 md:space-y-0 md:space-x-4 mt-4">
      {/* Items per page dropdown */}
      <div className="flex items-center space-x-2 hidden sm:flex">
        <label htmlFor="itemsPerPage" className="font-medium">
          Items per page:
        </label>
        <select
          id="itemsPerPage"
          value={pageSize}
          onChange={onItemsPerPageChange}
          className="border rounded px-2 py-1"
        >
          <option value="1">1</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </select>
      </div>

      {/* Pagination Controls */}
      <div className="flex items-center space-x-2 flex-wrap">
        {/* Previous Button */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`rounded-full px-3 py-1 hidden sm:block ${
            currentPage === 1
              ? "bg-gray-300 text-white cursor-not-allowed"
              : "bg-white text-gray-700 hover:bg-gray-100"
          }`}
        >
          ← Previous
        </button>

        {/* Page Buttons */}
        {pagesToShow.map((page, index) =>
          page === "..." ? (
            <span key={`ellipsis-${index}`} className="px-2 text-gray-500">
              ...
            </span>
          ) : (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`rounded-full px-3 py-1 hidden sm:block ${
                page === currentPage
                  ? "saveButton"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              {page}
            </button>
          )
        )}

        {/* Next Button */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`rounded-full px-3 py-1 hidden sm:block ${
            currentPage === totalPages
              ? "bg-gray-300 text-white cursor-not-allowed"
              : "bg-white text-gray-700 hover:bg-gray-100"
          }`}
        >
          Next →
        </button>
      </div>

      {/* Custom style for current page */}
      <style>{`
        .saveButton {
          background-color: #4169E2;
          border: 1px solid #4169E2;
          color: white;
        }
      `}</style>
    </div>
  );
}; 

export default Pagination;
